import { jsx as _jsx } from "react/jsx-runtime";
import { BrazeContext } from '../BrazeProvider/BrazeProvider';
import { BrazeConsumer } from '../BrazeConsumer/BrazeConsumer';
const withBraze = (placement) => (OpenComponent, EmptyComponent = () => null) => () => (_jsx(BrazeContext.Consumer, { children: ({ subscribeConsumer, trackingLibrary }) => {
        return (_jsx(BrazeConsumer, { placement: placement, subscribeConsumer: subscribeConsumer, openComponent: OpenComponent, emptyComponent: EmptyComponent, trackingLibrary: trackingLibrary }));
    } }));
export default withBraze;
//# sourceMappingURL=withBraze.js.map